<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="_pageSetting.primary"
    :secondary="_pageSetting.secondary"
    :customUpdateAction="customUpdateAction"
    :staticModelData="staticModelData"
    titleKey="name"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/role_type";
import subModel from "@/models/role";
export default {
  data(){
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      staticModelData: (modelData, fields) => {
        subModel.scopeFields.forEach((scopeItem) => {
          if (fields[scopeItem].items.length) {
            fields[scopeItem].items.forEach((valueItem) => {
              let result = true;
              if (valueItem.value) {
                valueItem.value.forEach((item) => {
                  if (result) {
                    result = modelData.scopes.includes(item);
                  }
                });
                if (result) {
                  modelData[scopeItem] = [
                    ...(modelData[scopeItem] || []),
                    ...valueItem.value,
                  ];
                }
              }
            });
          }
        });
      },
      customUpdateAction: (modelData) => {
        modelData.scopes = [];
        subModel.scopeFields.forEach((scopeItem) => {
          if (modelData[scopeItem] !== null && modelData[scopeItem] !== undefined) {
            modelData.scopes.push(...modelData[scopeItem]);
          }
        });
      },
    }
  },
  computed: {
    _pageSetting() {
      return {
        primary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "角色資訊",
                fields: ["locales", "sequence"],
              },
              {
                title: "角色權限",
                fields: subModel.scopeFields,
              },
            ],
          },
        ],
        secondary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "前台是否需要設定限閱領域",
                fields: ["has_factory_system"],
              },
              {
                title: "前台是否需要設定限閱轄下單位",
                fields: ["has_factory_scope"],
              },
            ],
          },
        ],
      };
    }
  }
};
</script>